export const mdl06Urls = {
  promotion: '/mdl06/promotion/search',
}
